/**
 * ScribePage
 *
 * Route: /prioritization/scribe
 *
 * Dedicated page for the Scribe agent intake flow.
 * Paste or dictate free-form text and Scribe extracts
 * structured item proposals for you to review and accept.
 */

import { Link } from 'react-router-dom';
import { PenLine, Settings } from 'lucide-react';
import { PageHeader } from '../../components/prioritization/PageHeader';
import { ScribePanel } from '../../components/prioritization/scribe/ScribePanel';
import { getCurrentWorkspaceId } from '../../lib/supabaseSync';

export default function ScribePage() {
  const workspaceId = getCurrentWorkspaceId() ?? '';

  return (
    <div className="space-y-6">
      <PageHeader
        icon={<PenLine className="h-4 w-4 text-[var(--text-sec)]" />}
        iconBg="bg-[var(--hover-tint)]"
        title="Scribe"
        subtitle="Paste or dictate free-form text and Scribe will extract structured item proposals for you to review before they're created."
        actions={
          <Link
            to="/prioritization/settings/scribe-agent"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-[var(--rule)] text-[var(--text-sec)] hover:bg-[var(--surface)] transition-colors no-underline"
          >
            <Settings className="h-3.5 w-3.5" />
            Configure
          </Link>
        }
      />

      <div className="card">
        <ScribePanel workspaceId={workspaceId} />
      </div>
    </div>
  );
}
